/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { EVALUATION: de },
  'en-US': { EVALUATION: en },
  'es-ES': { EVALUATION: es },
  'it-IT': { EVALUATION: it },
  'pt-PT': { EVALUATION: pt }
};
